import type { CoachingNote, Player } from "@/lib/types";
import { EvidenceList, feedbackMeta } from "./EvidenceList";
export type RecentObservationsRailProps = {
  observations: CoachingNote[];
  players?: Player[];
  loading?: boolean;
  activeObservationId?: number | null;
  onOpenObservation: (note: CoachingNote) => void;
};
export function RecentObservationsRail({
  observations,
  players,
  loading,
  activeObservationId,
  onOpenObservation,
}: RecentObservationsRailProps) {
  return (
    <div
      className="review-evidence-panel"
      data-testid="coach-review-observations-rail"
    >
      <EvidenceList
        label="Recent observations"
        players={players}
        loading={loading}
        empty="No tactical observations yet. Use Mark observation to save this board."
        testId="coach-review-observations-strip"
        rowTestId="coach-review-observation-card"
        onOpen={onOpenObservation}
        rows={observations.map((n) => ({
          value: n,
          id: n.id,
          title:
            n.title?.trim() ||
            n.event_title?.trim() ||
            n.player_summary?.trim() ||
            "Observation",
          position: "Board",
          metadata: feedbackMeta("Observation", null, n.category, n.visibility),
          visibility: n.visibility,
          playerIds: n.player_ids,
          active: activeObservationId === n.id,
        }))}
      />
    </div>
  );
}
